import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'Do I need to be in shape to start?',
  answer: 'No. Storm adult classes are designed to help you get in shape. Drills are scaled to your current fitness level and you progress at your own pace.'
}, {
  question: 'Am I too old to start martial arts?',
  answer: 'No. Storm has adult students from their twenties through senior citizens. Taekwondo is highly adaptable, and we focus on personal progress — not comparing you to anyone else.'
}, {
  question: 'Do I need previous martial arts experience?',
  answer: 'No prior experience required. The majority of adult students at Storm started with zero martial arts background. Previous experience is also welcome.'
}, {
  question: 'I trained Taekwondo before. Do you honor my belt?',
  answer: 'Storm honors previous Taekwondo belt rankings when appropriate. Tell a Storm coach about your background — school, last belt, time since you trained — and we will place you in the right class.'
}, {
  question: 'What style of Taekwondo does Storm teach?',
  answer: 'Storm teaches WT / World Taekwondo style — the Olympic discipline. Our curriculum is aligned with Kukkiwon / WT standards, the global governing body of Taekwondo.'
}, {
  question: 'Is this just self-defense training?',
  answer: 'No. Self-defense foundations are part of training, but adult classes are full Olympic-style Taekwondo — fitness, technique, sparring fundamentals, forms, and belt progression. For dedicated self-defense classes see Storm.'
}, {
  question: 'What should I wear to my first class?',
  answer: 'Comfortable athletic clothing — t-shirt, sweatpants or leggings. Bare feet on the mat. No uniform purchase required for your trial class.'
}, {
  question: 'Where is Storm located?',
  answer: 'Storm Taekwondo is at 24786 Crestview, Farmington Hills, MI 48335 — easy to reach from Novi, Commerce, Walled Lake, Wixom, Livonia, Northville and Waterford.'
}];
export function AdultFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-532" />;
}